import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import * as  Globals from '../../../shared/globals';
import { HttpClientService } from '../../../shared/http-client-service';
import { ConfigService } from '../../../config/config.service';
import { SessionService } from '../../../shared/services/session.service';

@Injectable()
export class LoginService {
    http: HttpClient;
    httpClient: HttpClientService;
    baseUrl;
    isExternalApp: boolean = false;

    constructor(http: HttpClient, config: ConfigService, httpClient: HttpClientService, private sessionService: SessionService) {
        this.http = http;
        this.httpClient = httpClient;
        this.baseUrl = config.get('apiUrl');
        if (!this.baseUrl) {
            config.load().then(() => {
                this.baseUrl = config.config['apiUrl'];
            });
        }
    }

    public logout() {
        this.sessionService.removeItem('id_token');
        this.sessionService.removeItem('isLoggedIn');
        this.sessionService.removeItem('lastLoggedIn');
        this.sessionService.removeItem('loginTimeRecorded');
        this.sessionService.removeItem('setParcelDefaults');
        this.sessionService.removeItem("isWorkLocationAssignedToUser");
        this.sessionService.removeItem("id_token");
        Globals.setTokenKey('Not-Set');
        Globals.authUser.isLoggedIn = false;
    }

    // -- POST,PUT,DELETE METHODS --//
    public getAuthToken(data: any, headers: HttpHeaders) {
        return this.http.post(this.baseUrl + 'token', data, { headers: headers }).pipe(map(res => {
            return res;
        }));
    }

    public isUserLoggedIn(): boolean {
        if (this.sessionService.getItem('id_token') !== 'Not-Set' && this.sessionService.getItem('isLoggedIn') === 'true') {
            return true;
        } else {
            return false;
        }
    }

    public setPasswordExpiry(data: string) {
        return this.httpClient.post('api/UserManagement/PasswordExpiryReset', JSON.stringify(data)).pipe(map(responsedata => {
            let body = responsedata;
            return body || {};
        }));
    }

    public getRoleBasedMenu(userId) {
        return this.httpClient.get(this.baseUrl + 'api/Login/GetUserRoleModuleAccess/' + userId).pipe(map(responsedata => {
            var result = responsedata; // #viracor 
            return result || {};
        }));
    }

    public getLoginUserRole(): any {
        return this.sessionService.getItem('roleId');
    }

    public getEncryptionKeys() {
        console.log(this.baseUrl + 'api/Login/GetEncryptionKeys');
        return this.httpClient.get('api/Login/GetEncryptionKeys').pipe(map(responsedata => {
            var result = responsedata;
            return result || {};
        }));
    }
}